
define('css!vb/components/messagebar/styles',[],function(){});
